var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"alert-info sticky"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"message"},[_c('p',[_vm._v(_vm._s(_vm.translations.inProgressMessage))])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"icon"},[_c('i',{staticClass:"af-icons-md af-icons-md-circle-processing"})])
}]

export { render, staticRenderFns }